---
fr:
  production_simulation_plan:
    axis_names:
      energy: Énergie
      inflow_energy: Énergie d'entrée
      price: Prix
      reservoir_energy: Énergie du réservoir
      volume: Volume (MWh)
    chart_names:
      actual_market_price: Prix du marché réel
      actual_production: Production réelle
      estimated_inflow: Débit estimé
      estimated_price: Prix estimé
      estimated_reservoir_volume: Volume de réservoir estimé
      past_planned_production: Production prévue passée
      planned_production: Production prévue
